module.exports = __webpack_public_path__ + "img/旭瑞大型工程监理监管综合信息化平台V1.0.38137e29.jpg";